import React from 'react'

const UnlockFill: React.FC<DefaultPropsIcon> = (props) => {
  const { size = 18, onClick, className, color = '#FFFFFF' } = props
  return (
    <span className={['anticon', 'anticon-setting', className || ''].join(' ')} onClick={onClick}>
      {/* <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 2.25C11.07 2.25 12.75 3.92 12.75 6L12.74 7.5L13.07 7.5C13.74 7.5 13.98 7.56 14.23 7.7C14.47 
          7.83 14.66 8.02 14.79 8.26C14.93 8.51 15 8.75 15 9.42L15 13.82C15 14.49 14.93 14.73 14.79 14.98C14.66 
          15.22 14.47 15.41 14.23 15.54C13.98 15.68 13.74 15.75 13.07 15.75L4.92 15.75C4.25 15.75 4.01 15.68 3.76 
          15.54C3.52 15.41 3.33 15.22 3.2 14.98C3.06 14.73 3 14.49 3 13.82L3 9.42C3 8.75 3.06 8.51 3.2 8.26C3.33 
          8.02 3.52 7.83 3.76 7.7C4.01 7.56 4.25 7.5 4.92 7.5L5.24 7.5L5.25 6C5.25 3.92 6.92 2.25 9 2.25ZM9 3.75C7.75 
          3.75 6.75 4.75 6.75 6L6.74 7.5L11.24 7.5L11.25 6C11.25 4.75 10.24 3.75 9 3.75Z"
          fill={color}
        />
      </svg> */}

      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g clipPath="url(#clip1436_62702)">
          <path
            d="M7.5 6.66L7.5 8.33L14.53 8.33C15.27 8.33 15.54 8.41 15.81 8.55C16.08 8.7 16.29 8.91 
            16.44 9.18C16.58 9.45 16.66 9.72 16.66 10.46L16.66 15.36C16.66 16.1 16.58 16.37 16.44 
            16.64C16.29 16.91 16.08 17.13 15.81 17.27C15.54 17.42 15.27 17.5 14.53 17.5L5.47 
            17.5C4.72 17.5 4.45 17.42 4.18 17.27C3.91 17.13 3.7 16.91 3.55 16.64C3.41 16.37 3.33 
            16.1 3.33 15.36L3.33 10.46C3.33 9.72 3.41 9.45 3.55 9.18C3.7 8.91 3.91 8.7 4.18 
            8.55C4.45 8.41 4.72 8.33 5.47 8.33L5.83 8.33L5.83 6.66C5.83 4.33 7.66 2.5 10 2.5C11.08 
            2.5 12.16 2.91 12.91 3.75C13.41 4.25 13.83 4.91 14 5.66C14.16 6.08 13.83 6.58 13.41 
            6.66C13 6.75 12.5 6.5 12.41 6.08C12.25 5.66 12.08 5.25 11.75 4.91C10.83 3.91 9.25 3.91 
            8.25 4.91C7.75 5.41 7.5 6 7.5 6.66Z"
            fill={color}
          />
        </g>
      </svg>
    </span>
  )
}

export default UnlockFill
